/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import classnames from 'classnames';
import ProductLabel, { ProductLabelProperty } from 'components/atoms/ProductLabel';

import styles from './index.module.css';

interface ProductLabelSetProperty {
	labelData: ProductLabelProperty[];
	direction?: 'row' | 'column'; // row: 商品hashtag_, column: 優惠label
	className?: string;
}

const ProductLabelSet: React.FC<ProductLabelSetProperty> = ({
	direction = 'row',
	labelData = [],
	className,
}) =>
	labelData.length !== 0 ? (
		<div className={classnames(styles.productLabelSet, styles[direction], className)}>
			{labelData.map((label, index) => {
				let { text } = label;

				if (direction === 'row') {
					// 橫向排列時，一定要傳兩個 label 進來
					// hashtag1 紫色
					if (index === 0) {
						label = { ...label, backgroundColor: '#E6E3F1', textColor: '#8C7DBE' };
					}

					// hashtag2 藍色
					if (index === 1) {
						label = { ...label, backgroundColor: '#E3F7FD', textColor: '#17B9EC' };
					}

					text = `${text.slice(0, 12)}`;

					// 兩個 label 只顯示五個字
					if (labelData[0].text && labelData[1].text) {
						text = `${text.slice(0, 5)}`;
					}
				}

				return (
					<ProductLabel
						{...label}
						className={classnames(styles.label)}
						key={label.text || index}
						text={text}
					/>
				);
			})}
		</div>
	) : null;

export default ProductLabelSet;
